import React, { Suspense, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import { Box, Tooltip } from '@mui/material'
import { useStyles } from './inboxStyles'
import { TabPanelProps } from '../../../interfaces/inbox'
import { PathologistsReceiveSlides } from './../../HOC/PathologistsReceiveSlides'
import { RootState } from '../../../reducers'
import TableComponent from '../Common/TableComponent'
import { AssignedColumns } from './table_def'
import { Clear as ClearIcon } from '@mui/icons-material'
import { fetchCompletedData, fetchInboxData, fetchRecentlyReleasedData } from '../../../actions'
import AssignedCases from './AssignedCases'
import CompletedCases from './CompletedCases'

function a11yProps(index: unknown) {
  return {
    id: `case-worklist-${index}`,
    'aria-controls': `case-worklist-${index}`,
  }
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`case-worklist-${index}`}
      aria-labelledby={`case-worklist-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0} pt={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

export function InboxPage({ user }): JSX.Element {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)
  const [receiveSlides, setReceiveSlides] = useState(false)
  const [onTrfSearch, setOnTrfSearch] = useState(false)
  const [tabChanged, setTabChanged] = useState(0)
  const dispatch = useDispatch()

  useEffect(() => {
    handleReceiveSlides()
  }, [])

  // eslint-disable-next-line @typescript-eslint/ban-types
  const handleChange = (event, newValue: number) => {
    if (newValue === undefined) return
    setValue(newValue)
  }

  function handleReceiveSlides() {
    setReceiveSlides(true)
  }

  function handleNoSlides() {
    setReceiveSlides(false)
  }

  function clearSearch() {
    handleChange(null, tabChanged)
    setReceiveSlides(true)
  }

  useEffect(() => {
    if (value === 0) {
      dispatch(
        fetchInboxData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: 10,
          filterField: 'created_datetime',
          filterValue: null,
          caseView: 'assigned',
          startDate: null,
          endDate: null,
          sortOrder: 'asc',
          sortField: 'case_number',
        }),
      )
      dispatch(
        fetchRecentlyReleasedData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: 10,
          filterField: 'case_number',
          filterValue: null,
          caseView: 'recently_released',
          startDate: null,
          endDate: null,
          sortOrder: 'asc',
          sortField: 'created_datetime',
        }),
      )
      dispatch(
        fetchCompletedData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: 10,
          filterField: 'updated_datetime',
          filterValue: null,
          caseView: 'completed',
          startDate: null,
          endDate: null,
          sortOrder: 'desc',
          sortField: 'case_number',
        }),
      )
    }
    if (value === 1) {
      dispatch(
        fetchCompletedData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: 10,
          filterField: 'updated_datetime',
          filterValue: null,
          caseView: 'completed',
          startDate: null,
          endDate: null,
          sortOrder: 'desc',
          sortField: 'case_number',
        }),
      )
    }
  }, [dispatch, user, value])

  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <Box className={classes.mt}>
          <AppBar position="static" className={classes.appBar}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="case-worklist"
              classes={{
                indicator: classes.indicator,
              }}
            >
              <Tab label="Assigned to me" {...a11yProps(0)} onClick={handleReceiveSlides} />
              <Tab label="Completed" {...a11yProps(1)} onClick={handleNoSlides} />
              {onTrfSearch && (
                <Tab label="" {...a11yProps(4)} style={{ margin: '0px', minWidth: '0px', padding: '0px' }} />
              )}
              <div className={classes.pathologistLoadBalancer}>
                {receiveSlides && <PathologistsReceiveSlides userId={user} />}
                {/* <SearchTRFInput user={user} role={role} onSearch={onSearch} /> */}
              </div>
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <AssignedCases userId={user} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <CompletedCases userId={user} />
          </TabPanel>
        </Box>
      </Suspense>
    </div>
  )
}
